import { render, staticRenderFns } from "./HistoryComments.vue?vue&type=template&id=68f0ebdb&"
import script from "./HistoryComments.vue?vue&type=script&lang=js&"
export * from "./HistoryComments.vue?vue&type=script&lang=js&"
import style0 from "./HistoryComments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports